"use client"

import { useServerInsertedHTML } from "next/navigation"
import { VWOScript } from "vwo-smartcode-nextjs"

interface VwoSmartCodeProps {
  accountId: string
}

/**
 * Injects VWO SmartCode 2.2 into <head> via useServerInsertedHTML.
 *
 * Uses vwo-smartcode-nextjs (VWOScript), not wingify-smartcode-nextjs. Trimble
 * accounts still resolve on dev.visualwebsiteoptimizer.com; edge.wingify.net/tag
 * returns 404 for these account IDs until migrated to SmartCode 3.0.
 *
 * OneTrust consent is configured in the VWO/Wingify admin (Cookie Consent Manager).
 *
 * settingsTimeout bounds the worst-case anti-flicker hide (previously 2000ms,
 * during which the whole body was invisible) to VWO's own recommended ceiling
 * for avoiding a perceptible blank page while still giving most requests time
 * to apply their variation before reveal.
 */
const VwoSmartCode = ({ accountId }: VwoSmartCodeProps) => {
  useServerInsertedHTML(() => (
    <VWOScript
      accountId={accountId}
      version={2.2}
      type="ASYNC"
      settingsTimeout={400}
      hideElement="body"
      hideElementStyle="opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important"
    />
  ))

  return null
}

export default VwoSmartCode
